var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50011 8.15159C5.31136 8.15159 3.53345 6.37367 3.53345 4.18493C3.53345 1.99618 5.31136 0.225342 7.50011 0.225342C9.68886 0.225342 11.4668 2.00326 11.4668 4.19201C11.4668 6.38076 9.68886 8.15868 7.50011 8.15868V8.15159ZM7.50011 1.28784C5.89928 1.28784 4.59595 2.59118 4.59595 4.19201C4.59595 5.79284 5.89928 7.09618 7.50011 7.09618C9.10095 7.09618 10.4043 5.79284 10.4043 4.19201C10.4043 2.59118 9.10095 1.28784 7.50011 1.28784Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8467 14.7745H1.15332C0.862904 14.7745 0.62207 14.5336 0.62207 14.2432C0.62207 11.1761 3.19332 9.34863 7.49999 9.34863C11.8067 9.34863 14.3779 11.1761 14.3779 14.2432C14.3779 14.5336 14.1371 14.7745 13.8467 14.7745ZM1.7129 13.712H13.28C12.8833 10.7441 9.1504 10.4111 7.4929 10.4111C5.8354 10.4111 2.10249 10.7441 1.70582 13.712H1.7129Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.6db36d5b.svg";
export { ForwardRef as ReactComponent };